import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ButtonExit from "../../../../components/UI/button/ButtonExit";
import ButtonAdd from "../../../../components/UI/button/ButtonAdd";

/**
 * Подтверждение удаления текстуры (как ModalConfirm в проекте).
 */
const TextureDeleteConfirmDialog = ({
    open,
    textureName,
    affectedDetailNames = [],
    onClose,
    onConfirm,
}) => {
    const hasAffected = affectedDetailNames.length > 0;

    return (
        <Dialog
            open={Boolean(open)}
            onClose={onClose}
            PaperProps={{
                style: {
                    minWidth: 400,
                    borderRadius: 8,
                },
            }}
        >
            <DialogTitle textAlign="center">
                Вы уверены, что хотите удалить?
            </DialogTitle>
            <DialogContent>
                <Typography textAlign="center" sx={{mb: hasAffected ? 1.5 : 0}}>
                    «{textureName || "Элемент"}» будет удалён(а) из каталога.
                </Typography>
                {hasAffected ? (
                    <Box>
                        <Typography sx={{mb: 1, color: "text.secondary"}}>
                            Без текстуры останутся детали:
                        </Typography>
                        <Box
                            component="ul"
                            sx={{
                                m: 0,
                                pl: 2.5,
                                maxHeight: 180,
                                overflowY: "auto",
                            }}
                        >
                            {affectedDetailNames.map((name, index) => (
                                <Typography
                                    component="li"
                                    key={`${name}-${index}`}
                                    sx={{mb: 0.5}}
                                >
                                    {name}
                                </Typography>
                            ))}
                        </Box>
                    </Box>
                ) : (
                    <Typography textAlign="center" color="text.secondary">
                        На сцене нет деталей с этой текстурой.
                    </Typography>
                )}
            </DialogContent>
            <DialogActions sx={{p: "1.25rem"}}>
                <ButtonExit text="Отменить" onClick={onClose}/>
                <ButtonAdd text="Да" onClick={onConfirm}/>
            </DialogActions>
        </Dialog>
    );
};

export default TextureDeleteConfirmDialog;
